module.exports = __webpack_public_path__ + "img/avatar-3.bd15a283.png";